module.exports = __webpack_public_path__ + "static/media/Page 2.bab1faf9.mp4";